export const CustomFieldActionRegistry = Symbol('CustomFieldActionRegistry');
